import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, CircularProgress } from '@mui/material';
import { Stack } from '@mui/system';

import WaveUIAccordion from '@/shared/components/widgets/WaveUIAccordion';
import ProfilesTemplateSchemas from '@/shared/types/shipping/profilesTemplateSchemas.type';
import ShippingProfile from '@/shared/types/shipping/shippingProfile.type';

import CustomsDetails from '../../components/CustomsDetails/CustomsDetails';
import useCustomsDetails from '../../components/CustomsDetails/hooks/useCustomsDetails';

type CustomsDetailsPanelProps = {
  templateSchemas: ProfilesTemplateSchemas;
  isLoading: boolean;
  onUpdateCustomsDetails: (value: Partial<ShippingProfile>) => void;
};

const CustomsDetailsPanel: FC<CustomsDetailsPanelProps> = ({
  templateSchemas,
  isLoading,
  onUpdateCustomsDetails,
}) => {
  const { t } = useTranslation(['shipping', 'common']);

  const customsDetailsState = useCustomsDetails();

  return (
    <WaveUIAccordion
      defaultExpanded={false}
      title={t('shipping:customsDetails')}
    >
      <Stack alignItems='flex-start'>
        <CustomsDetails
          templateSchemas={templateSchemas}
          customsDetailsState={customsDetailsState}
        />
        <Button
          variant='contained'
          startIcon={
            isLoading && (
              <CircularProgress size='16px' color='inherit' sx={{ mr: 1 }} />
            )
          }
          onClick={() => {
            const isValid = customsDetailsState.onValidate();

            if (isValid && !isLoading) {
              void onUpdateCustomsDetails({
                customs_details: {
                  ...customsDetailsState.customsDetailsForm,
                  broker: {
                    ...customsDetailsState.brokerForm,
                  },
                },
              });
            }
          }}
        >
          {t('common:saveChanges')}
        </Button>
      </Stack>
    </WaveUIAccordion>
  );
};

export default CustomsDetailsPanel;
